import { render, staticRenderFns } from "./ComissaoVendedor.vue?vue&type=template&id=5953edec&scoped=true"
import script from "./ComissaoVendedor.vue?vue&type=script&lang=js"
export * from "./ComissaoVendedor.vue?vue&type=script&lang=js"
import style0 from "./ComissaoVendedor.vue?vue&type=style&index=0&id=5953edec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5953edec",
  null
  
)

export default component.exports